export * from "./OnlineAppointment";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { OnlineAppointmentProps } from "./OnlineAppointment.types";

export const OnlineAppointmentLoadable = lazy(
  () => import("./OnlineAppointment")
);

export const OnlineAppointment = (props: OnlineAppointmentProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<div>Loading</div>}>
        <OnlineAppointmentLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
